import {newAxios} from './index'
import { enum_UpdateContract } from '@/util/paramsConfig'
import { filterProp } from '@/util'

//创建合同
export const Req_CreateContract = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/pact/add`,
    data
  })()
}

//获取合同详情
export const Req_GetContract = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/pact/info`,
    data
  })()
}

//修改合同
export const Req_UpdateContract = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/pact/update`,
    data:filterProp(enum_UpdateContract,data)
  },'json')()
}

//更新合同状态
export const Req_UpdateContractStatus = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/pact/state/update`,
    data
  })()
}

//获取证件列表
export const Req_GetAnnexList = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/attachment/page/list`,
    data
  })()
}

//获取收费情况列表
export const Req_GetChargeSituationList = function (data) {
  return newAxios({
    url:'/chargeSituationList',
    data
  })()
}

//获取客户合同列表
export const Req_GetContractList = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/pact/list`,
    data
  })()
}

//获取工作分配列表
export const Req_GetWorkList = function (data) {
  return newAxios({
    url:'/workAssign',
    data
  })()
}


// WEBPACK FOOTER //
// ./src/request/contract.js